"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.megaphone = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const megaphone = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'megaphone-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.3354 3.32918C15.5895 3.45623 15.75 3.71593 15.75 4V7.41841C16.3412 7.69928 16.75 8.30191 16.75 9V10C16.75 10.6981 16.3412 11.3007 15.75 11.5816V15C15.75 15.2841 15.5895 15.5438 15.3354 15.6708C15.0813 15.7979 14.7773 15.7705 14.55 15.6L10.75 12.75H9.58558L8.72761 16.1819C8.64414 16.5158 8.34415 16.75 8 16.75H7C6.76905 16.75 6.55098 16.6436 6.40885 16.4616C6.26672 16.2795 6.21638 16.0422 6.27239 15.8181L7.03942 12.75H6.5C4.70507 12.75 3.25 11.2949 3.25 9.5C3.25 7.70508 4.70507 6.25 6.5 6.25H10.75L14.55 3.4C14.7773 3.22956 15.0813 3.20214 15.3354 3.32918ZM11 11.25C11.1623 11.25 11.3202 11.3026 11.45 11.4L14.25 13.5V5.5L11.45 7.6C11.3202 7.69737 11.1623 7.75 11 7.75H6.5C5.5335 7.75 4.75 8.53351 4.75 9.5C4.75 10.4665 5.5335 11.25 6.5 11.25H11Z', fill: '#4B5563' })));
};
exports.megaphone = megaphone;
